// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import { LabelIdentifier } from '@awsui/component-toolkit/internal/analytics-metadata';

interface GeneratedAnalyticsMetadataFormComponent {
  name: 'awsui.Form';
  label: string;
}

export interface GeneratedAnalyticsMetadataFormFragment {
  component: {
    name: GeneratedAnalyticsMetadataFormComponent['name'];
    label: LabelIdentifier;
  };
}
